import styled from 'styled-components';

export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  min-height: calc(100vh - 160px);
  padding: 48px 20px;
`;

export const NotFoundTitle = styled.h1`
  font-size: 22px;
  font-weight: 300;
  margin: 16px 0 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const NotFoundDescription = styled.p`
  font-size: 14px;
  line-height: 1.6;
  margin: 8px 0 0;
  max-width: 440px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const NotFoundActions = styled.div`
  margin-top: 24px;
`;

export const NotFoundHomeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #0a7465;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease;

  &:hover {
    background: #0a5f53;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const NotFoundBackLink = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-top: 16px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};

  button {
    display: inline-flex;
    align-items: center;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: #0a7465;
    font-weight: 500;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;
